export function getAntdPopupContainer(triggerNode?: HTMLElement): HTMLElement {
  return triggerNode?.parentElement || document.body
}
